export { ErrorsInstrumentation } from './instrumentation';

export { buildStackFrame, getDataFromSafariExtensions, getStackFramesFromError, parseStacktrace } from './stackFrames';

export type { ErrorEvent, ExtendedPromiseRejectionEvent } from './types';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/errors/index.ts